const carouselItems = [
  {
    title: '2026年度选秀黑料盘点：那些被掩盖的真相',
    desc: '深度整理今年各大选秀节目中未被公开报道的内幕事件，从赛制操纵到选手背景，每日大赛黑料帮你还原一个真实的选秀江湖。',
    tag: '年度专题',
    img: 'https://readdy.ai/api/search-image?query=Grand%20stage%20with%20dramatic%20red%20curtains%20and%20golden%20spotlights%2C%20talent%20show%20finale%20atmosphere%2C%20theatrical%20drama%20with%20mysterious%20vibe%2C%20entertainment%20industry%20aesthetic%2C%20cinematic%20wide%20shot%20photography%20with%20deep%20contrast&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
  },
  {
    title: '电竞圈资本暗战：各大俱乐部背后的神秘金主',
    desc: '揭秘电竞赛事背后错综复杂的资本关系网，从投资人到关联企业，每日大赛黑料绘制了一份完整的电竞资本地图。',
    tag: '深度专题',
    img: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20boardroom%20with%20dramatic%20lighting%20and%20esports%20trophies%2C%20power%20and%20money%20aesthetic%2C%20mysterious%20business%20meeting%20vibe%2C%20gold%20accents%20on%20dark%20background%2C%20cinematic%20corporate%20photography%20with%20shadows&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
  },
  {
    title: '综艺节目剪辑操控术：你的情绪被精准设计',
    desc: '资深后期从业者匿名揭秘综艺节目的剪辑套路——如何通过镜头语言、音乐和节奏编排操纵观众情感，让每日大赛黑料的吃瓜群众看清屏幕背后的真相。',
    tag: '行业揭秘',
    img: 'https://readdy.ai/api/search-image?query=Video%20editing%20suite%20with%20multiple%20monitors%20in%20dark%20room%2C%20dramatic%20red%20and%20blue%20screen%20glow%2C%20professional%20editing%20aesthetic%2C%20behind%20the%20scenes%20production%20vibe%2C%20cinematic%20tech%20photography%20with%20contrast&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
  },
  {
    title: '网红大赛商业模式全解析：流量如何变现为黑料',
    desc: '从打赏到带货，从广告到签约，每日大赛黑料深度分析网红主播大赛背后的完整商业链条，揭示每一个环节的灰色操作。',
    tag: '商业揭秘',
    img: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20scene%20with%20streaming%20equipment%20in%20dramatic%20lighting%2C%20influencer%20culture%20aesthetic%2C%20money%20and%20fame%20contrast%2C%20dark%20elegant%20vibe%20with%20gold%20accents%2C%20cinematic%20photography%20with%20deep%20moody%20tone&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
  },
  {
    title: '吃瓜群众生存指南：在大赛黑料中如何辨别真假',
    desc: '每日大赛黑料结合多年吃瓜经验，总结出一套实用的信息辨别方法论。从信源追踪到逻辑校验，助你在海量大赛八卦中保持清醒头脑。',
    tag: '实用指南',
    img: 'https://readdy.ai/api/search-image?query=Detective%20desk%20with%20magnifying%20glass%20and%20newspaper%20clippings%20in%20dramatic%20lighting%2C%20investigation%20aesthetic%2C%20mystery%20solving%20atmosphere%2C%20warm%20amber%20desk%20lamp%20glow%2C%20cinematic%20noir%20photography%20with%20deep%20shadows&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            每日大赛黑料深度策划，全方位透视大赛内幕与八卦生态
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <article
              key={i}
              className={`rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-accent-300 transition-all cursor-pointer ${
                i === 0 ? 'md:col-span-2 lg:col-span-3' : ''
              }`}
            >
              <div className={`flex flex-col ${i === 0 ? 'lg:flex-row' : ''}`}>
                <div className={`relative overflow-hidden ${i === 0 ? 'lg:w-1/2 aspect-[16/10] lg:aspect-auto lg:min-h-[280px]' : 'aspect-[4/3]'}`}>
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className={`p-5 md:p-6 flex flex-col justify-center ${i === 0 ? 'lg:w-1/2' : ''}`}>
                  <h3 className={`font-semibold text-foreground-900 leading-snug hover:text-primary-600 transition-colors ${i === 0 ? 'text-lg md:text-xl' : 'text-base md:text-lg'}`}>
                    {item.title}
                  </h3>
                  <p className={`mt-3 text-foreground-600 leading-relaxed ${i === 0 ? 'text-sm md:text-base' : 'text-sm line-clamp-3'}`}>
                    {item.desc}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}